import styled from "styled-components";
import { NumberAvatar } from '@assets';
export const Loader = styled.div`
width: 100%;
height: calc(100vh - 120px);
display: flex;
align-items: center;
justify-content: center;
`;

export const RootContainer =styled.div`
  padding: 20px 0;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-gap: 12px;
  margin: 0 0 12px 0;
`;

export const Image = styled.img.attrs({
  alt: 'icon',
})`
  width: 75px;
  height: 75px;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
`;

export const Title = styled.div`
  text-align: center;
  color: #101415;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0 0 22px 0
`;

export const PlayerListContainer = styled.div`
  width: 100%;
  margin: 0 0 0 0;
  overflow: auto;
`

export const PlayerBox = styled.div`
  background: #F7F7F7;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 1px;
`

export const NumberContainer = styled.div`
  width: 60px;
  height: 60px;
  position: relative;
`
export const NumberBackgroundAvatar = styled(NumberAvatar)`
`
export const Number = styled.p`
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  position: absolute;
  top: 23px;
  left: 24px;
  color: #101415;
`

export const DataContainer = styled.div`
  flex-grow: 1;
  gap: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NameAndAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PlayerName = styled.p`
  flex-grow: 1;
  color: #101415;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const Amount = styled.p`
  color: #C21C05;
  text-align: right;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const PhoneNumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PhoneNumber = styled.p`
  flex-grow: 1;
  color:  #808080;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
